import { useToast, UseToastOptions } from "@chakra-ui/react";
import { ReactNode } from "react";

export const useToastSuccess = () => {
  const toast = useToast();
  return (message: ReactNode, options?: UseToastOptions) => {
    toast({
      title: message,
      status: "success",
      duration: 3000,
      isClosable: true,
      ...options,
    });
  };
};
